import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../user/signup.css';

const UserLogin = () => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    let navigate = useNavigate();

    
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/uhome'); 
        }
    }, [navigate]);

    const submitHandler = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setError('');

        axios.post('https://pkrealestateapi.onrender.com/user/login', {
            userName: userName,
            password: password
        })
        .then(res => {
            console.log(res.data);
            localStorage.setItem('token', res.data.token); 
            localStorage.setItem('userName', res.data.userName);
            navigate('/uhome');
        })
        .catch(err => {
            console.log(err);
            setError(err.response?.data?.message || 'Username or password incorrect');
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <div className="signup-wrapper">
            <div className="signup-container">
            <div className="company-title">
                    <h2>P.K Real Estate</h2>
                </div>
                <div className="signup-header">
                    <h1>Login</h1>
                    <div className="animated-underline"></div>
                </div>
                
                {error && <div className="error-message">{error}</div>}
                
                <form onSubmit={submitHandler} className="signup-form">
                    <div className="form-group">
                        <input
                            type='text'
                            required
                            className="form-input"
                            onChange={(e) => setUserName(e.target.value)}
                            disabled={isLoading}
                        />
                        <label className="form-label">Username</label>
                        <span className="form-line"></span>
                    </div>

                    <div className="form-group">
                        <input
                            type='password'
                            required
                            className="form-input"
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={isLoading}
                        />
                        <label className="form-label">Password</label>
                        <span className="form-line"></span>
                    </div>
                    <button type='submit' className="submit-btn" disabled={isLoading}>
                        {isLoading ? (
                            <div className="loader-container">
                                <div className="loader"></div>
                                <span>Login...</span>
                            </div>
                        ) : (
                            'Login'
                        )}
                    </button>
                </form>
                <div className="account-link-container">
                    <Link to="/signup" className="account-link">Don't have an account? Sign up</Link>
                </div>
            </div>
        </div>
    );
}

export default UserLogin;